<template>
  <div>
    <v-card class="mx-auto mt-12" height="100%">
      <v-app-bar color="primary" class="secondary--text">
        <v-toolbar-title>
          Logout
        </v-toolbar-title>
      </v-app-bar>
      <div>
        <v-progress-circular
          class="my-5"
          :size="70"
          :width="7"
          color="secondary"
          indeterminate
        />
      </div>
    </v-card>
    <logout-helper v-if="triggerLogoutHelper" @logoutDone="blackMagic" cookie-name="nettex-www" />
    <v-alert
      v-model="alertState"
      :color="isError ? 'red' : 'green'"
      class="mt-3"
      dark
      dismissible>
      <span v-if="Array.isArray(alertMessage)">
        <span v-for="(message, idx) in alertMessage" :key="idx"> {{ message }} <br v-if="idx!==alertMessage.length"></span>
      </span>
      <span v-else>
        {{ alertMessage }}
      </span>
    </v-alert>
  </div>
</template>

<script>
import LogoutHelper from './LogoutHelper'

// const DOMAIN = 'https://asia-east2-auth-97f6c.cloudfunctions.net/'
// const DOMAIN = 'https://auth-97f6c.appspot.com/'
const VERSION = process.env.VUE_APP_VERSION
const DOMAIN = process.env.VUE_APP_API_ROOT
const ORIGIN = window.location.origin.includes('accounts') ? window.location.origin.split('accounts')[1] : window.location.origin.split('auth')[1]

export default {
  name: 'Logout',
  components: { LogoutHelper },
  data: () => ({
    isLoading: false,
    fullPage: false,
    triggerLogoutHelper: false,
    alertState: false,
    isError: false,
    alertMessage: ''
  }),
  computed: {
    noRedirect: function () {
      return this.$route.query.noredirect !== undefined
    }
  },
  mounted() {
    console.log(`Version: ${VERSION}`)
    console.log(`No redirect: ${this.noRedirect}`)
    this.checkOrigin()
    this.logout()
  },
  methods: {
    checkOrigin() {
      // ! Cheap and nasty way to enforce everyone uses accounts domain
      if (window.location.origin.includes('auth') && this.$route.query.noredirect !== undefined) {
        const origin = window.location.origin.split('auth')[1]
        window.location = `https://accounts${origin}/logout${window.location.search}`
      }
    },
    errorCountdown(counter) {
      if (counter >= 0) {
        this.isLoading = true
        setTimeout(this.errorCountdown.bind(null, counter - 1), 1000)
      } else {
        this.alertMessage = ['This is taking longer than expected', '', 'If you are not redirected soon please let Nettex know']
        this.isError = true
        this.alertState = true
      }
    },
    blackMagic() {
      if (this.$route.query.noredirect !== undefined) return
      const callback = this.$route.query.callback
      let path = this.$route.query.path
      if (!path) path = '/' // blank path if none given
      path = path.split('%26').join('&') //? Re-encode escaped ampersand
      if (path[0] !== '/') path = '/' + path
      window.location = `https://${callback}.web.app${path}`
    },
    async logout() {
      const url = DOMAIN + 'logout'
      const method = 'POST'
      const mode = 'cors'
      const credentials = 'include'
      const headers = {
        'content-type': 'application/json',
        'x-auth-cookie': document.cookie
      }
      this.isLoading = true
      let response, status
      try {
        // const t0 = performance.now()
        response = await fetch(url, { method, mode, credentials, headers })
        // console.log(`logout done: ${performance.now() - t0}`)
        status = response.status
        response = await response.json()
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }

      // await firebaseLogout() // ? I don't think this does what we want
      this.$cookies.remove('auth', null, ORIGIN)
      this.$cookies.remove('Session', null, ORIGIN)
      this.$cookies.remove('www', null, ORIGIN)
      this.$cookies.remove('nettex-www', null, ORIGIN)
      this.$cookies.remove('staff', null, ORIGIN)
      this.$cookies.remove('staffStaging', null, ORIGIN)

      if (status !== 200) {
        console.log(`Logout failed! Status: ${status} Error: ${response.message}`)
      }
      let callback = this.$route.query.callback
      if (callback === 'nettex' || callback === 'ordering-nettex') {
        this.triggerLogoutHelper = true
        this.errorCountdown(10)
        return
      }
      // ? No-redirect flag for debugging purposes (check cookies on page, force-reload, etc)
      if (this.$route.query.noredirect !== undefined) return
      if (!callback) callback = 'www'
      let path = this.$route.query.path
      if (!path) path = '/' // blank path if none given
      path = path.split('%26').join('&') //? Re-encode escaped ampersand
      if (path[0] !== '/') path = '/' + path
      window.location = `https://${callback}${ORIGIN}`
    },
  },
}
</script>
<!--
<style scoped>
.link {
  text-decoration: none;
  border-bottom: solid 1px;
}
</style>
-->
